import { getHash, } from "components/Utils";
import { PoolRollResult, SingleRollResult, } from ".";

type RollResult = PoolRollResult | SingleRollResult;

const ROLL_STORAGE_NAME = "rolls";
const MAX_STORAGE_LENGTH = 50;

const getStorageItemId = (): string => {
    const hash = getHash(ROLL_STORAGE_NAME);
    return `logs_${hash}`;
};

export const storeRollHistory = (result: RollResult): void => {
    // get the current logs so we can add to them
    const logs = retrieveRollHistory() || [];

    // remove the first element to make room for one more
    if (logs.length === MAX_STORAGE_LENGTH) {
        logs.shift();
    }

    logs.push(result);

    const id = getStorageItemId();
    const json = JSON.stringify(logs);

    // this should never be full but just to play it safe...
    try {
        localStorage.setItem(id, json);
    } catch (error) {
        console.error("Error saving roll data to local storage", error, json);
    }
};

export const retrieveRollHistory = (): (RollResult[] | undefined) => {
    const id = getStorageItemId();
    const item = localStorage.getItem(id);

    if (!item) {
        return undefined;
    }

    // in theory, json.length should be at most 99
    // so we don't need to trim it here; we can do that when saving
    const logs = JSON.parse(item);
    return logs;
};

export const clearRollHistory = (): void => {
    const id = getStorageItemId();
    localStorage.removeItem(id);
};

export const getRollHistoryCount = (): number => {
    return retrieveRollHistory()?.length || 0;
};
